import { gql } from "@apollo/client";

export default gql`
  query getPreviousRecurringMeetingQuery($beforeMeetingId: Int!) {
    previousMeeting: meeting(beforeMeetingId: $beforeMeetingId) {
      id
    }
  }
`;
